export default {"src":"/_next/static/media/bg-latest-news.a29ad05d.svg","height":511,"width":1143,"blurWidth":0,"blurHeight":0};